import { render, staticRenderFns } from "./add-stake-form.vue?vue&type=template&id=3106ff0a&scoped=true"
import script from "./add-stake-form.vue?vue&type=script&lang=js"
export * from "./add-stake-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106ff0a",
  null
  
)

export default component.exports